import { render, staticRenderFns } from "./ShowCustomerPage.vue?vue&type=template&id=6705c558&scoped=true&"
import script from "./ShowCustomerPage.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowCustomerPage.vue?vue&type=style&index=0&id=6705c558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705c558",
  null
  
)

export default component.exports